module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-caret-down--black-2efd5ce5287d71a4e1f0724a3a503c76.svg";